import ScalarIconHouse_vue_vue_type_script_setup_true_lang_default from "./ScalarIconHouse.vue.script.js";
//#region src/components/ScalarIconHouse.vue
var ScalarIconHouse_default = ScalarIconHouse_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconHouse_default as default };

//# sourceMappingURL=ScalarIconHouse.js.map